import { render, staticRenderFns } from "./tabsScooll.vue?vue&type=template&id=f9cef25e&scoped=true"
import script from "./tabsScooll.vue?vue&type=script&lang=js"
export * from "./tabsScooll.vue?vue&type=script&lang=js"
import style0 from "./tabsScooll.vue?vue&type=style&index=0&id=f9cef25e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9cef25e",
  null
  
)

export default component.exports